import { render, staticRenderFns } from "./indexCloudPos.vue?vue&type=template&id=5c4e52d4&scoped=true&"
import script from "./indexCloudPos.vue?vue&type=script&lang=js&"
export * from "./indexCloudPos.vue?vue&type=script&lang=js&"
import style0 from "./indexCloudPos.vue?vue&type=style&index=0&id=5c4e52d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e52d4",
  null
  
)

export default component.exports